import { FC } from 'react';

import { PreviousResponseRowSkeleton } from './PreviousResponseRowSkeleton';

import { ChangeIndicator } from '@/components/atoms';
import { QuestionPreviousResponseItem } from '@/types/questions';
import { formatRowDate } from '@/utils/formatRowDate';

import { TableCell, TableRow } from '../Table/Table';

type PreviousResponseRowProps = {
  rowData: QuestionPreviousResponseItem;
  isLoading?: boolean;
};

export const PreviousResponseRow: FC<PreviousResponseRowProps> = ({ rowData, isLoading }) => {
  if (isLoading) {
    return <PreviousResponseRowSkeleton />;
  }

  const { date, score, comparedToAverage, participationRate } = rowData;

  const { full } = formatRowDate(date);

  return (
    <TableRow>
      <TableCell className="py-[18px]">
        <p>{full}</p>
      </TableCell>
      <TableCell className="py-[18px]">
        <div className="flex items-center gap-1">
          <span className="text-body-14-semibold text-custom-warm-grey-950">{score}%</span>{' '}
          <ChangeIndicator changeValue={comparedToAverage} />
        </div>
      </TableCell>
      <TableCell className="py-[18px]">
        <p className="text-body-14-medium text-custom-warm-grey-950">{participationRate}%</p>
      </TableCell>
    </TableRow>
  );
};
